module.exports = __webpack_public_path__ + "static/media/0362_Small.e01c0084.jpg";